'use strict';

module.exports = function isArrayish(obj) {
	if (!obj) {
		return false;
	}

	return obj instanceof Array || Array.isArray(obj) ||
		(obj.length >= 0 && obj.splice instanceof Function);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/is-arrayish/index.js
// module id = 216
// module chunks = 0